import { combineReducers } from 'redux';
import { createReduceObject as createFormReduceObject } from './reducer';
import createSaga from './saga';
import { reducerRegistry } from '../../../../../reducerRegistry';

// eslint-disable-next-line import/prefer-default-export
export function registryCombineReducer(reducerName) {
  const combine = combineReducers({
    ...createFormReduceObject(reducerName)
  });
  reducerRegistry.register(reducerName, combine, createSaga);
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/reducers/dynamic/taskFrom/combineRegistry.js